import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BooksSection } from '../components/BooksSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FaqSection } from '../components/FaqSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { PostCtaSection } from '../components/PostCtaSection';
import { Footer } from '../components/Footer';
import { StickyCta } from '../components/StickyCta';
import { ProductStructuredData } from '../components/ProductStructuredData';
import { ResourceHints } from '../components/ResourceHints';
import { MetaPixel } from '../components/MetaPixel';
import { PurchaseToast } from '../components/PurchaseToast';
import { LiveViewersBadge } from '../components/LiveViewersBadge';
import { useLiveCopies } from '../hooks/useLiveCopies';
import { usePurchaseNotifications } from '../hooks/usePurchaseNotifications';
interface SalesPageProps {
  copiesLeft: number;
  showStickyCta: boolean;
  showPurchaseToasts: boolean;
  showLiveViewers: boolean;
}
export function SalesPage({
  copiesLeft,
  showStickyCta,
  showPurchaseToasts,
  showLiveViewers
}: SalesPageProps) {
  const live = useLiveCopies(copiesLeft);
  const {
    current
  } = usePurchaseNotifications(showPurchaseToasts);
  return <div className={`min-h-full w-full bg-noir-950 font-sans text-cream ${showStickyCta ? 'pb-20' : ''}`} data-id="element-331" data-mp="3fhrtbeyfe8jc">
      <MetaPixel data-id="element-332" data-mp="28355z5j03nl1" />
      <ResourceHints data-id="element-333" data-mp="243nzc8ru8kea" />
      <ProductStructuredData data-id="element-334" data-mp="2434o1awp0u98" />
      <AnnouncementBar copiesLeft={live.copiesLeft} data-id="element-335" data-mp="24232udlyqrds" />
      <Hero copiesLeft={live.copiesLeft} data-id="element-336" data-mp="25l33za8q6m24" />
      <main data-id="element-337" data-mp="25m4nm33t4gvg">
        <PainSection data-id="element-338" data-mp="25ll6golzdwih" />
        <SolutionSection data-id="element-339" data-mp="25iyy4mr9ncz7" />
        <BooksSection data-id="element-340" data-mp="2akg06llhl5hd" />
        <ValueStackSection data-id="element-341" data-mp="2ailev66azbcr" />
        <ComparisonSection data-id="element-342" data-mp="2ahttspac0w0q" />
        <TestimonialsSection data-id="element-343" data-mp="1vmw09t3g60i2" />
        <FaqSection data-id="element-344" data-mp="1vllzux94gg89" />
        <GuaranteeSection data-id="element-345" data-mp="1vm41k9ejzmnk" />
        <UrgencySection copiesLeft={live.copiesLeft} claimed={live.claimed} totalCopies={live.totalCopies} claimPulse={live.claimPulse} data-id="element-346" data-mp="1vp009zy86fd2" />
        <FinalCtaSection data-id="element-347" data-mp="1ms8wt2hcfy8g" />
        <PostCtaSection data-id="element-348" data-mp="1rksas0jy0vds" />
      </main>
      <Footer data-id="element-349" data-mp="1rm3n4orgfbgi" />
      {showLiveViewers && <LiveViewersBadge data-id="element-350" data-mp="1rn5397nbuo53" />}
      {showStickyCta && <StickyCta copiesLeft={live.copiesLeft} data-id="element-351" data-mp="1cwxi2k5xqr0p" />}
      {showPurchaseToasts && <PurchaseToast event={current} offsetForStickyBar={showStickyCta} data-id="element-352" data-mp="1huzavwt5y4pd" />}
    </div>;
}